export default {
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  data () {
    return {
      tabs: this.config.defaultTab ? this.config.defaultTab : '',
      disable: this._.zipObject(Object.keys(this.config.items), this._.fill(Array(Object.keys(this.config.items).length), false)),
      tabKey: 1
    }
  },
  created () {
    this.checkEmptyData()
  },
  methods: {
    showWhenDefaultTabEmpty (scaffolding) {
      let vm = this
      for (let key in vm.config.items) {
        if (vm._.isEqual(vm.config.items[key].scaffolding, scaffolding) && key === vm.config.defaultTab) {
          vm.disable[key] = true
          vm.tabs = vm.config.showWhenDefaultTabEmpty
        } else {
          vm.disable[key] = false
        }
      }
    },
    checkEmptyData () {
      for (let key in this.config.items[this.config.defaultTab].scaffolding.items) {
        let item = this.config.items[this.config.defaultTab].scaffolding.items[key]
        // check default tab empty
        if (item.fieldName === '{this.root}') {
          if (this._.isEmpty(this.modelProps)) {
            this.disable[this.config.defaultTab] = true
            this.tabs = this.config.showWhenDefaultTabEmpty
          }
        } else if (this._.isEmpty(this.modelProps[item.fieldName])) {
          this.disable[this.config.defaultTab] = true
          this.tabs = this.config.showWhenDefaultTabEmpty
        } else {
          this.disable[this.config.defaultTab] = false
        }
      }
    }
  },
  watch: {
    // modelProps: {
    //   handler: function () {
    //     this.checkEmptyData()
    //   },
    //   deep: true
    // }
  }
}
